import React, { Component } from 'react'
import { Navbar, Nav } from 'reactstrap'
import {BrowserRouter, Route, Switch} from 'react-router-dom'
import {bindActionCreators} from 'redux'
import { connect } from 'react-redux'

import Login from './Login'
import LogOutButton from './LogoutButton'
import Navigation from './Navigation'

import * as viewActions from '../actions/viewActions'

import '../styles/navbar.css'

class NavBar extends Component {

    render() {
        return (
            <div>
                <BrowserRouter forceRefresh={false}>
                    <div>
                        <Navbar color="light" light expand="md">
                          { this.props.session.active === false ? <Nav className={"yellow-ititoca m-auto"} navbar> <p>Back-Office ITITOCA</p>  </Nav> : <Nav className={"yellow-ititoca ml-auto"} navbar>  <LogOutButton></LogOutButton> </Nav>}
                            </Navbar>
                        <Switch>
                            <Route path='/' component={this.props.session.active === false ? Login : Navigation}  />
                        </Switch>
                    </div>
                </BrowserRouter>
            </div>
        );
    }
}

function mapStateToProps (state) {
  return {
    session: state.session
  }
}

function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators(viewActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NavBar)



// WEBPACK FOOTER //
// ./src/components/Navbar.js